import { inject, Injectable } from '@angular/core';
import { ApiService } from '@features/api';

import { Venue } from '../models';

export interface VenueResponse {
  venue: Venue;
  redirect?: boolean;
  external_url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VenuesService {
  #api = inject(ApiService);

  /**
   * Returns the full response envelope (not just the venue) so callers can act on
   * the partner-venue `redirect`/`external_url` signal.
   */
  get(locationId: string, venueId: string) {
    return this.#api.get<VenueResponse>(`/locations/${locationId}/venues/${venueId}`);
  }
}
